<template>
    <div>
        <h3 style="padding-left:20px;">
            {{
            courseId === "" || courseId === null || courseId === undefined
            ? "添加课程"
            : "编辑课程"
            }}
        </h3>
        <div class="inner-box">
            <h5 class="subtitle">请填写课程相关信息</h5>
            <div class="box">
                <BInputText
                        v-model="courseInfo.courseName"
                        :maxLength="25"
                        :required="true"
                        label-text="课程名称"
                        placeholder="请输入名称"
                />
            </div>
            <div class="box">
                <BInputPullDown
                        label-name="课程专业"
                        placeholder="选择课程所属专业"
                        :required="true"
                        v-model="courseInfo.courseMajorId"
                        :Options="courseMajorList"
                />
            </div>
            <div class="box">
                <BInputText
                        label-text="课程课时"
                        :required="true"
                        v-model="courseInfo.courseTime"
                        placeholder="请输入总课时"
                />
            </div>
            <div class="box">
                <label class="labelClass"
                    >课程简介</label
                >
                <BInputTextArea
                    class="area-class"
                    v-model="courseInfo.remark"
                    placeholder="请输入课程简介"
                    :maxLength="1000"
                />
            </div>
            <div class="search-result">
                <div class="search-functions-headers">
                    <div class="search-functions">
                        <BBtnPrimary style="margin-left: 50px;"
                            v-if="courseId === '' || courseId === null || courseId === undefined"
                                :clicked="save"
                                btn-txt="立即添加"
                        />
                        <BBtnPrimary v-else :clicked="save" btn-txt="立即修改"/>
                        <BBtnPrimary :clicked="back" btn-txt="返回"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import {
        courseAddInit,
        courseAddSave,
        courseAddUpdate,
        courseAddDetail,
    } from "@/api/course";
    import BInputText from "../../components2/BInputText";
    import BInputPullDown from "../../components2/BInputPullDown";
    import BBtnPrimary from "../../components2/BBtnPrimary";
    import BInputTextArea from "../../components2/BInputTextArea";
    import Vue from "vue";

    export default {
        name: "CourseManagementAdd",
        components: {
            BInputText,
            BInputPullDown,
            BBtnPrimary,
            BInputTextArea,
        },
        data: () => ({
            snackbarObj: {
                snackbar: false,
                timeout: -1,
                color: "",
                text: "",
            },
            // 课程信息
            courseInfo: {
                courseName: "",
                courseMajorId: "",
                courseTime: "",
                remark: "",
            },
            // 课程专业
            courseMajorList: [],
            // 课程id
            courseId: null,

            navi: [
                {name: "course-management"},
                {name: "course-management-add"},
            ],
        }),
        created() {
            if (sessionStorage.getItem("store")) {
                this.$store.replaceState(
                    Object.assign(
                        {},
                        this.$store.state,
                        JSON.parse(sessionStorage.getItem("store"))
                    )
                );
                sessionStorage.removeItem("store");
            }
            window.addEventListener("beforeunload", () => {
                sessionStorage.setItem("store", JSON.stringify(this.$store.state));
            });
        },
        destroyed() {
            this.$store.commit("REMOVE_COURSEID");
        },
        // 页面载入之前
        beforeRouteEnter(to, from, next) {
            next((vm) => {
                const params = {
                    courseId: vm.$route.params.courseId,
                };
                if (
                    params.courseId !== null &&
                    params.courseId !== "" &&
                    params.courseId !== undefined
                ) {
                    // 把不为空的参数存入缓存
                    vm.$store.commit("SET_COURSE_MANAGE_DETAIL_PARAMS", params);
                }
                // 参数赋值
                console.log(vm.$store.state.courseManagement_courseId)
                if (
                    vm.$store.state.courseManagement_courseId !== undefined &&
                    vm.$store.state.courseManagement_courseId !== null &&
                    vm.$store.state.courseManagement_courseId !== ""
                ) {
                    
                    vm.courseId = vm.$store.state.courseManagement_courseId;
                }
                  vm.courseAddInit();
                if (
                    vm.courseId !== "" &&
                    vm.courseId !== null &&
                    vm.courseId !== undefined
                ) {
                    vm.trainCourseInfo(vm.courseId);
                }
                // vm.getNowDate()
            });
        },
        beforeMount() {
            this.$store.commit('SET_NAVI_DATA', this.navi);
        },
        methods: {

            async courseAddInit() {
                const data = await courseAddInit();
                this.courseMajorList = data.data.trainMajorList;
                // this.multiSelectData.data = data.data.trainClassList;
            },
            // 课程详情
            async trainCourseInfo(id) {
                await this.courseAddInit()
                var param = {
                    id: id,
                };
                const data = await courseAddDetail(param);
                this.courseInfo = {
                    courseName: data.data.courseName,
                    courseMajorId: data.data.courseMajorId,
                    courseTime: data.data.courseTime.toString(),
                    remark: data.data.remark,
                    // playBackFlg: data.data.playBackFlg,
                    status: data.data.status,
                };
            },
            // 返回
            back() {
                if (
                    this.courseId !== null &&
                    this.courseId !== "" &&
                    this.courseId !== undefined
                ) {
                    this.$router.push({
                        name: "course-management-public",
                        params: {
                            courseId: this.courseId,
                        },
                    });
                } else {
                    this.$router.push({
                        name: "course-management",
                        query: {backFlg: "1"},
                    });
                }
            },
            save() {
                const param = {};
                if (this.saveCheck()) {
                    param.courseName = this.comUtils.trim(this.courseInfo.courseName);
                    param.courseMajorId = this.courseInfo.courseMajorId;
                    param.courseTime = this.courseInfo.courseTime;
                    param.remark = this.courseInfo.remark;
                    if (this.courseId) {
                        param.id = this.courseId;
                        this.courseAddUpdate(param);
                    } else {
                        this.courseAddSave(param);
                    }
                }
            },
            async courseAddSave(param) {
                const data = await courseAddSave(param);
                if (data.code === 0) {
                    Vue.prototype.$vsnackbar.show(data.msg);
                    this.back()
                } else {
                    Vue.prototype.$valertbar.show(data.msg);
                }
            },
            async courseAddUpdate(param) {
                const data = await courseAddUpdate(param);
                if (data.code === 0) {
                    Vue.prototype.$vsnackbar.show(data.msg);
                    this.back()
                } else {
                    Vue.prototype.$valertbar.show(data.msg);
                }
            },
            
            // 保存check
            saveCheck() {
                // 课程名称check
                if (
                    this.courseInfo.courseName === null ||
                    this.courseInfo.courseName === "" ||
                    this.courseInfo.courseName === undefined
                ) {
                    Vue.prototype.$valertbar.show("请输入课程名称");
                    return false;
                }

                // 课程专业check
                if (
                    this.courseInfo.courseMajorId === null ||
                    this.courseInfo.courseMajorId === "" ||
                    this.courseInfo.courseMajorId === undefined
                ) {
                    Vue.prototype.$valertbar.show("请选择课程专业");
                    return false;
                }
                // 课程课时check
                if (
                    this.courseInfo.courseTime === "" ||
                    this.courseInfo.courseTime === undefined ||
                    this.courseInfo.courseTime === null
                ) {
                    Vue.prototype.$valertbar.show("请输入课程课时");
                    return false;
                }
                if (
                    String(this.courseInfo.courseTime) !==
                    String(this.courseInfo.courseTime)
                        .replace(/[^\\.\d]/g, "")
                        .replace(".", "") ||
                    this.courseInfo.courseTime === "0"
                ) {
                    Vue.prototype.$valertbar.show("课时必须为正整数！");
                    return;
                }

                return true;
            }, 
        },
    };
</script>

<style scoped>
    .main2 {
        position: relative;
        /*margin: 5px 30px 5px 30px;*/
        padding-top: 28px;
        display: flex;
        flex-wrap: wrap;
    }

    .search-result {
        display: block;
        position: relative;
        margin: 30px 25px 5px 25px;
    }

    .search-functions-headers {
        position: relative;
        display: flex;
        justify-content: space-between;
        top: 0;
    }

    .search-functions {
        position: relative;
        top: 0;
        display: flex;
    }

    .search-result-summary {
        display: flex;
        align-items: center;
    }

    .search-result-summary .summary {
        margin: 0 50px 0 0;
    }

    .search-result-table {
        border-spacing: 0px;
        padding-bottom: 50px;
        width: 100%;
        margin-top: 10px;
    }

    .table-header-row {
        height: 67px;
        background: #f6f6f6;
    }

    .table-header-row th {
        text-align: left;
        padding: 10px;
    }

    .table-result-row {
        height: 78px;
        font-weight: 500;
        color: #333333;
    }

    .table-result-row td {
        border-bottom: 1px solid #ebebeb;
        padding: 10px;
        text-align: left;
    }

    .btn-detail {
        margin: 0 20px 0 20px;
        color: #0171a3;
        cursor: pointer;
    }

    .btn-delete {
        color: #fd1f58;
        cursor: pointer;
    }

    .box {
        display: flex;
        /* align-items: center; */
        flex-wrap: wrap;
    }

    .box-time-pick {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
    }

    .box-time-title {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        margin-left: 90px;
    }

    .box-left {
        border-top: 1px solid black;
        border-bottom: 1px solid black;
        border-right: 1px solid black;
    }

    .box-right {
        border-top: 1px solid black;
        border-bottom: 1px solid black;
    }

    .inner-box {
        display: flex;
        flex-direction: column;
        width: 100%;
        flex-wrap: wrap;
        position: relative;
        justify-content: flex-start;
    }

    .label-box {
        color: #333333;
        text-align: right;
        font-size: 14px;
        margin: 0 10px 0 10px;
    }

    .label-box-sign {
        text-align: right;
        color: #333333;
        font-size: 14px;
        margin: 0 10px 0 23px;
    }

    .subtitle {
        color: #999999;
        margin: 15px 10px 15px 20px;
    }
    .box-time{
        display: flex;
        align-items: flex-start;
        flex-wrap: wrap;
    }
    .area-class {
        width: 400px;
        height: 120px;
    }
    .labelClass {
        margin: 0 15px 0 15px;
        text-align: right;
        width: 65px;  
    }
</style>
